import {
	ChangeDetectorRef,
	Component,
	Inject, // EventEmitter,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
	L10N_CONFIG,
	L10N_LOCALE,
	L10nConfig,
	L10nLocale,
	L10nTranslatePipe,
	L10nTranslationService
} from 'angular-l10n';

import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { FormControl } from "@angular/forms";
import { FlexModule, MediaObserver } from "@ngbracket/ngx-layout";
import { ReplaySubject, Subject } from "rxjs";
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { BreadcrumbService } from "../../shared/breadcrumb/breadcrumb.service";
import { ErrorHelper } from "../../shared/error.helper";
import { LoggerService } from "../../shared/logger.service";
import { Kernantwort } from "../../shared/response/kernantwort.model";
import { SessionService } from "../../shared/session.service";
import { Eintrag } from "../eintrag/eintrag.model";
import { Tabelle } from "../immerdrin/tabelle/tabelle";
import { KategorieEintragDialogComponent } from './kategorieeintragdialog.component';

const PATH_FILE = 'app/protected/kategorieeintrag/kategorieeintrag.component.ts';
const OBJ_LNG_NAME = 'eintrag';
const BACKEND_PATH_PREFIX = 'eintrag';

@Component({
    selector: 'oase-kategorieeintrag',
    templateUrl: './kategorieeintrag.component.html',
    styleUrls: ['./kategorieeintrag.component.css'],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FlexModule]

})
export class KategorieeintragComponent extends Tabelle<Eintrag> {

	spList: Eintrag[] = new Array<Eintrag>();
	// neu: Lieferant = null;
	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredKategorieeintragen: ReplaySubject<Eintrag[]> = new ReplaySubject<Eintrag[]>(1);
	public kategorieId: string;

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService, public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public datepipe: DatePipe,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/fb",
				PATH_FILE: PATH_FILE,
				extraDataForAdding: { }
			}
		);
		if(this.isUnterschriftFaehig())
      this.displayedColumns = ['unterschrift','check','titel','download'];
    else
      this.displayedColumns = ['check','titel','download'];
	    this.title.setTitle(this.getTitle());
	}

	getApiParams() {
		this.kategorieId = this.route.snapshot.paramMap.get("kategorieId");
		return "kategorie/"+this.kategorieId;
	}

  isUnterschriftFaehig(): boolean {
    return this.route.snapshot.paramMap.get("kategorieId")==='50bf7592-87eb-4dd3-8073-8904708805a7'
  }

	setBetrachtet(eintrag: Eintrag){
		this._logger.log(PATH_FILE + ' - setBetrachtet für Eintrag: ', eintrag);
		this.http.get<Eintrag>(this.REST_API + '/betrachtet/' + eintrag.id).subscribe({
			next: (data) => {
			  this._logger.log(PATH_FILE + ' - setBetrachtet response: ', data);
			  eintrag.betrachtet = data.betrachtet;
			},
			error: (err) => ErrorHelper.handleError(err,"Fehler beim Markieren von Eintrag als betrachtet",this._logger, this.translation)
		});
  	}

	setUnterzeichnet(eintrag: Eintrag){
		this._logger.log(PATH_FILE + ' - setUnterzeichnet für Eintrag: ', eintrag);
		this.dialog.open(KategorieEintragDialogComponent, {
			maxWidth: '100vw',
    		maxHeight: '100vh',
    		width: '50vw',
			data: {
				entry: eintrag,
				injSubject: this.translation.translate(OBJ_LNG_NAME+'.sicherheitsfrageueberschrift'),
				injQuestion: this.translation.translate(OBJ_LNG_NAME+'.sicherheitsfrage')
			}
        })
		.afterClosed()
		.subscribe((confirm) => {
			if (confirm) {
				this.http.get<Eintrag>(this.REST_API + '/unterzeichne/' + eintrag.id).subscribe({
					next: (data) => {
						this._logger.log(PATH_FILE + ' - setUnterzeichnet response: ', data);
						eintrag.unterzeichnet = data.unterzeichnet;
					},
					error: (err) => { 
						ErrorHelper.handleError(err,"Fehler beim Unterzeichnen des Eintrages",this._logger, this.translation)
					}
				});
			}
		});
  	}

	unterzeichnungAufheben(eintrag: Eintrag){
		this._logger.log(PATH_FILE + ' - unterzeichnungAufheben für Eintrag: ', eintrag);
		this.dialog.open(KategorieEintragDialogComponent, {
                data: {
                    entry: eintrag,
					injSubject: this.translation.translate(OBJ_LNG_NAME+'.sicherheitsfrageueberschriftaufhebung'),
					injQuestion: this.translation.translate(OBJ_LNG_NAME+'.sicherheitsfrageaufhebung')
                }
            })
            .afterClosed()
            .subscribe((confirm) => {
                if (confirm) {
					this.http.delete<Eintrag>(this.REST_API + '/unterzeichnetaufheben/' + eintrag.id).subscribe({
						next: (data) => {
						  this._logger.log(PATH_FILE + ' - unterzeichnungAufheben response: ', data);
						  eintrag.unterzeichnet = null;
						},
						error: (err) => { 
							ErrorHelper.handleError(err,"Fehler beim Aufheben der Unterzeichnung des Eintrages",this._logger, this.translation)
						}
					});
                }
            });
  	}

	showUnterzeichnenButton(eintrag: Eintrag): boolean {
		return eintrag.betrachtet && eintrag.unterzeichnet===null && this.isUnterschriftFaehig();
	}

	showUnterschriftZurueckziehenButton(eintrag: Eintrag): boolean {
		return eintrag.betrachtet && eintrag.unterzeichnet!==null;
	}

	getDownloadLink(anhang) {
		return this.apiConfigService.REST_API_BASE()+anhang.download;
	}

	getPdf(anhang) {
		return this.http
			.get(this.getDownloadLink(anhang), {
				responseType: "blob"
			});

	}

	download(eintrag: Eintrag, anhang: any) {
		this.getPdf(anhang).subscribe({
			next: (data) => {
				this.fehlerMain = null;
				let blob = new Blob([data], {type: 'application/pdf'});
				let downloadURL = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = downloadURL;
				link.target = "_blank";
				link.download = anhang.name+".pdf";
				link.click();
				if (! eintrag.betrachtet) this.setBetrachtet(eintrag);
			},
			error: (error) => {
				if (error.status === 404) {
					this.fehlerMain = new Kernantwort();
					this.fehlerMain.messagehtml = this.translation.translate("eintrag.kein_datei", {"name": anhang.name});
				} else {
					this.fehlerMain = ErrorHelper.handleError(error, "Fehler", this._logger, this.translation);
				}
			}
		});
}

	public markiereAlsHeruntergeladen(e: Eintrag){
		this._logger.log(PATH_FILE + ' - EINTRAG: ', e);
		this.http.get(this.REST_API + '/markiereAlsHeruntergeladen/' + e.id).subscribe({
			next: (data) => {
				this._logger.log(PATH_FILE + ' - got answer data: ', data);
				this.setBetrachtet(e);
			},
			error: (err) => {
				ErrorHelper.handleError(err,"Fehler beim Markieren von Herunterladen bei Eintrag",this._logger, this.translation)
			}
		});
	}
}